import { ContractClauseStatus } from '@/types/StatusType';
import { ClauseStatusBadge } from './statusbadge';

export type CounterProposalHistoryProps = {
  contractId: string;
  showDialogue: boolean;
  setShowDialogue: (showDialogue: boolean) => void;
};

export const FieldRow = ({
  icon: Icon,
  label,
  value,
  status,
}: {
  icon: React.ElementType;
  label: string;
  value?: string;
  status?: string;
}) => {
  return (
    <div className="flex items-start justify-between gap-3 p-3 rounded-md border bg-[#043a93]/10 border-[#043a93]/20 text-[#043a93]">
      <div className="flex items-start gap-2">
        <Icon className="w-4 h-4 mt-1 text-gray-300" />
        <div>
          <div className="capitalize text-sm font-medium text-gray-300">
            {label}
          </div>
          <div className="text-sm text-gray-300 whitespace-pre-wrap break-words">
            {value ?? '—'}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {status && ClauseStatusBadge(status as ContractClauseStatus)}
      </div>
    </div>
  );
};
